import { render, staticRenderFns } from "./combineSupRAndP.vue?vue&type=template&id=74fdab77&scoped=true&"
import script from "./combineSupRAndP.vue?vue&type=script&lang=js&"
export * from "./combineSupRAndP.vue?vue&type=script&lang=js&"
import style0 from "./combineSupRAndP.vue?vue&type=style&index=0&id=74fdab77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fdab77",
  null
  
)

component.options.__file = "combineSupRAndP.vue"
export default component.exports